import { render, staticRenderFns } from "./ModalAustralianResidencyStatusEdit.vue?vue&type=template&id=65f4f441&"
import script from "./ModalAustralianResidencyStatusEdit.vue?vue&type=script&lang=js&"
export * from "./ModalAustralianResidencyStatusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports